import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClockFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.554 14.667a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334m.5-9.5a.5.5 0 1 0-1 0V8a.5.5 0 0 0 .146.353l1.833 1.834a.5.5 0 1 0 .708-.707L9.054 7.793z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClockFilled);
export default ForwardRef;
